import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'

//Admin
import Login from '@/components/admin/Login'
import Dashboard from '@/components/admin/Dashboard'
import AdminComandas from '@/components/admin/comanda/AdminComandas'
import AdminPagamentos from '@/components/admin/comanda/AdminPagamentos'
import AdminMinhasVendas from '@/components/admin/comanda/AdminMinhasVendas'
import PDV from '@/components/admin/pdv/PDV'
import MarketPDV from '@/components/admin/pdv/MarketPDV'
import AdminProdutos from '@/components/admin/produto/Produtos'
import AdminProduto from '@/components/admin/produto/ProdutosCadastro'
import Colaboradores from '@/components/admin/colaborador/AdminColaboradores'
import AdminColaboradorCadastrar from '@/components/admin/colaborador/AdminColaboradorCadastrar'
import AdminColaboradorEditar from '@/components/admin/colaborador/AdminColaboradorEditar'
import Wiki from '@/components/wiki/WikiDash'
import Sac from '@/components/Sac'
import Relatorio from '@/components/admin/relatorio/AdminRelatorios'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },

    //Admin
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/admin',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/admin/pdv',
      name: 'PDV',
      component: PDV
    },
    {
      path: '/admin/pdv/:id',
      name: 'PDVComanda',
      component: PDV
    },
    {
      path: '/market/',
      name: 'MarketPDV',
      component: MarketPDV
    },
    {
      path: '/market/:id',
      name: 'MarketPDVUser',
      component: MarketPDV
    },
    {
      path: '/admin/minhas-compras',
      name: 'AdminMinhasVendas',
      component: AdminMinhasVendas
    },
    {
      path: '/admin/vendas/:id',
      name: 'AdminVendasUser',
      component: AdminMinhasVendas
    },
    {
      path: '/admin/vendas',
      name: 'AdminVendas',
      component: AdminComandas
    },
    {
      path: '/admin/pagamentos',
      name: 'AdminVendasPagamentos',
      component: AdminPagamentos
    },
    {
      path: '/admin/colaboradores',
      name: 'Colaboradores',
      component: Colaboradores
    },
    {
      path: '/admin/colaboradores/cadastrar',
      name: 'ColaboradoresCadastrar',
      component: AdminColaboradorCadastrar
    },
    {
      path: '/admin/colaboradores/:id',
      name: 'ColaboradoresEditar',
      component: AdminColaboradorEditar
    },
    {
      path: '/admin/produtos',
      name: 'Produtos',
      component: AdminProdutos
    },
    {
      path: '/admin/produtos/cadastrar',
      name: 'ProdutosCadastrar',
      component: AdminProduto
    },
    {
      path: '/admin/produtos/editar/:id',
      name: 'ProdutosEditar',
      component: AdminProduto
    },

    //Relatorio
    {
      path: '/admin/relatorios',
      name: 'Relatorios',
      component: Relatorio
    },

    //Wiki
    {
      path: '/admin/help',
      name: 'Wiki',
      component: Wiki
    },

    //Wiki
    {
      path: '/sac',
      name: 'Sac',
      component: Sac
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js